export default function LoadingPage() {
  return (
    <main className="system-page">
      <div className="system-page__inner">
        <div className="loader" role="status" aria-label="Loading" />
        <p>Loading...</p>
      </div>
    </main>
  );
}
